const getters = {
  mask: state => state.mask.sendMask,
  web3: state => state.web3.web3,
  userInfo: state => state.user.userInfo,
  orderInfo: state => state.order.orderInfo,
  stake: state => state.stake.token_ids,
  trade: state => state.trade.cardType,

}
export default getters